import React, { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import InputField from '../../form/InputField';
import LoadingButton from '../../form/LoadingButton';
import SubmitButton from '../../form/SubmitButton';
import { cities } from '../../../data/cities';
import { useUpdateResource } from '../../../hooks/useUpdateResource';

interface OwnerFormData {
  name: string;
  email: string;
  city: string;
}

interface OwnerFormProps {
  id:number;
  onSubmitSuccess?: () => void;
  defaultValues?:OwnerFormData
}

export default function UpdateOwnerFormByAdmin({
  defaultValues,
  id,
  onSubmitSuccess
}: OwnerFormProps) {
  const { t } = useTranslation();

  const { handleSubmit, register, formState: { errors } } = useForm<OwnerFormData>({
    defaultValues:{
        email:defaultValues?.email,
        name:defaultValues?.name,
        city:defaultValues?.city
    }
  });

   const {loading,updateResource} = useUpdateResource();
    
      const onSubmit: SubmitHandler<OwnerFormData> = async (data) => {
            await  updateResource(`owner?ownerId=${id}`,data, "admin",{
                method: "PUT",
                successMessage: t("update_success"),
                invalidateQueries:["owners-by-admin"],
              });
            if (onSubmitSuccess) onSubmitSuccess();
      };

  return (
    <>
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
      <InputField
        placeholder={t('owner.namePlaceholder')}
        register={register('name', { required: t('owner.nameRequired') })}
        error={errors.name}
      />

      <InputField
        placeholder={t('owner.emailPlaceholder')}
        register={register('email', { 
          required: t('owner.emailRequired'),
          pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: t('owner.emailInvalid') }
        })}
        error={errors.email}
        type="email"
      />

      <div>
        <select
          {...register("city", { required: t("required_field") })}
          className="border border-LightGrey3 rounded p-3 mt-2 w-full focus:outline-none focus:ring-2 focus:ring-primary placeholder:text-sm"
        >
          <option value="">{t('selectCity')}</option>
          {cities.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
        {errors.city && <span className="text-red-500">{errors.city.message}</span>}
      </div>

      {loading
        ? <LoadingButton  />
        : <SubmitButton  label={t("update")}/>
      }
    </form>
    </>
  );
}
